const VERSION_CODE = "Version 4.19.16";

export default VERSION_CODE;
